var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"bottom-bar-fix",attrs:{"app":"","bottom":"","dense":""}},[_c('div',{staticClass:"left ml-3"},[_c('spoiled-changelog')],1),_c('v-layout',{attrs:{"d-flex":"","justify-center":"","align-center":""}},[_vm._t("default")],2),_c('div',{staticClass:"right mr-3"},[_c('spoiled-to-top')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }